export const AppBaseUrl = import.meta.env.VITE_APP_BASE_URL;
export const AppBasePath = import.meta.env.VITE_APP_BASE_PATH;
export const AppVersion = import.meta.env.VITE_APP_VERSION;
export const AppName = import.meta.env.VITE_APP_NAME;
